export default {
    site: {
        common: {
            hello: "hallo",
            thankYou: "dank u",
            forMoreInfo: "voor meer info",
            hoverOverColumnHeaders: "beweeg over de kolomkoppen voor meer informatie.",
            username: "naam speler",
            score: "score",
            points: "punten",
            pointsAbbreviation: "ptn",
            chapter: "hoofdstuk",
            tier: "tier",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "ophalingen per dag",
            relicBoostPercent: "relikwie Boost %",
            mountainHallPercentShort: "Zalen od Berg %", // used in table heading keep it short.
            updated: "bijgewerkt",
            lastUpdated: "laatst bijgewerkt",
            created: "aangemaakt",
            role: "rol",
            Fellow: 'Lid',
            Ambassador: 'Ambassadeur',
            Mage: 'Magiër',
            Archmage: 'AartsMagiër',
            saveChanges: "bewaar veranderingen",
            copy: "kopieer",
            close: "sluiten",
            cancel: "snnuleren",
            action: "actie",
            date: "datum",
            Left: "vertrokken",
            Joined: "lid sinds",
            human: "mens",
            elf: "elf",
            search: "zoeken",
            enter: "enter",
            yes: "ja",
            no: "nee",
            tournament: "toernooi",
            tournaments: "toernooien",
            fellowship: "broederschap",
            player: "speler",
            member: "lid",
            history: "geschiedenis",
            tournamentHistory:  "toernooi geschiedenis",
            scoreHistory: "score geschiedenis",
            server: "server",
            lastWeekGain: "winst vorige week",
            comingSoon: "binnenkort verwacht",
            chest: "kist",
            yourServer: "jouw server",
            allServers: "alle servers",
            boosts: "Bonus",
            marble: "marmer",
            steel: "staal",
            planks: "hout",
            crystal: "kristal",
            scrolls: "boekrollen",
            silk: "zijde",
            elixir: "elixer",
            magic_dust: "toverstof",
            gems: "edelstenen",
            sentient: "sentient",
            goods: "goederen",
            average: "gemiddeld",
            expansions: 'uitbreidingen', // 5x5 grids
            cultureBoostMinimum: 'Cultuur Boost Minimum',
            cultureBoostCalculated: 'Berekende Cultuur Boost',
            neighborlyHelp: 'Burenhulp',
            neighborlyHelpAbbreviation: 'BH'
        },
        // HIGH PRIORITY
        nav: {
            home: "Home",
            players: "Spelers",
            fellowships: "Broederschappen",
            tournaments: "Toernooien",
            contact: "Contact",
            donate: "Doneer",
            faq: "FAQ",
            news: "Nieuws",
            privacyPolicy: "Privacybeleid",
            me: "Ik",
            myFellowship: "Mijn Broederschap",

            // NOTE USED AT THE MOMENT
            globalStats: "Global Stats",
            articles: "Artikelen",
            fellowshipAdventure: "Broederschaps Avonturen",
            recruit: "Recruteer",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Bekijk Stad op ElvenArchitect"
            ,obtainingLink: "Link ophalen"
            ,successMessage: "Succes! Klik op de onderstaande link om ElvenArchitect te starten"
            ,ageOfLink: "Bovenstaande link toont de stad in oude situatie: "
            ,clickToGetCurrentCity: "<-- Klik om de huidige stad te krijgen",
        },
        // High Priority
        playerSelection: {
            headline: "Bekijk site als",
            description: "Dit zal diverse delen van de website updaten die zijn aangepast naar de paginagebruiker. Onder andere: mijn broederschap, mijn gebruiker, toernooien en klassementen.",
            youAreViewing: `Je bekijkt de stad nu als {username} on {serverName}.`,
            changeUser: "Wijzig speler",
            enterYourUsernameToGetStarted: "Voer uw Elvenar-gebruikersnaam in om aan de slag te gaan",
            thisIsNotASignup:"Dit is geen aanmeldproces. Door uw spelersnaam in te voeren, passen we de site eenvoudig aan. Er zijn veel Elvenar-servers en we zullen de resultaten voor uw server weergeven. Ook zullen uw broederschap en persoonlijke gebruikerspaginakoppelingen beschikbaar worden."
        },
        searchBoxes: {
            enterFellowshipName: 'Voer de naam van je broederschap in',
            instructions: "Typ de naam en maak een selectie.",
            noFellowship: "Geen broederschap",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dagen geleden",
            minsAgo: "minuten geleden",
            hoursAgo: "uren geleden",
            justNow: "zojuist",
            never: "nooit",
        },
        home: {
            welcome: "Welkom op Elven Stats!",
            youAreViewing: "Je bekijkt de site nu als {username} op {serverName}",
            youCanChange: "Je kan van gebruiker wisselen door te klikken op de avatar rechtsboven -of- via <router-link to='/contact'>deze pagina</router-link>",
            features: {
                headline: "Kenmerken",
                fellowshipAdministration: {
                    headline: "<strong>SIMPELE</strong> Administratie van Broederschappen",
                    bullet1: "Automatisch volgen van bonus goederen om u te helpen de broederschap beter in balans te brengen",
                    bullet2: "Automatisch bijhouden/genereren van wekelijkse emailrapporten inclusief punten, toernooi deelname, maandelijkste groei en motivatie \"Accolades\" en persoonlijke beste scores",
                    bullet3: "Help bij het identificeren van de onbalans van uw mede BS leden, zoals voorraden of een onjuiste verhouding van goederen",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Integratie</strong>",
                    description: "Laad uw stad in paar seconden precies zoals die is in ElvenArchitect! Gebruik dit om uw volgende reorganisatie in de grote stad beter te plannen of om ruimte te vinden waarvan u niet wist dat u ze had! Zoek naar het ElvenArchitect-logo op de spelerpagina's."
                },
                advancedRankingLists: {
                    headline: "Geavanceerde <strong>Klassementen</strong>",
                    bullet1: "Ranglijst door ontgrendelde gebieden (om jezelf in dezelfde fase te vergelijken met spelers)",
                    bullet2: "Bekijk boosts, hoofdstukken, en meer in de spelerslijsten.",
                },
                fellowshipTournamentTracking: {
                    headline: "Broederschaps toernooi<strong>volgen</strong>",
                    description: "Zie hoe uw broederschap zich verhoudt ten opzichte van de anderen. Daag een andere broederschap uit voor een vriendschappelijke wedstrijd!",
                },
                matchMaking: {
                    headline: "<strong>Ideale</strong> combinaties",
                    description: "ElvenStats houdt voor broederschappen de bonusgoederen van spelers en ratio van goederen producties bij. Met deze informatie kunnen broederschappen de ideale kandidaten recruteren om hun goederentotaal in balans te brengen. Omgekeerd kunnen spelers zelf zo ook een broederschap vinden die hùn bonusgoederen nodig heeft. Dit bespaart uiteindelijk tijd en reduceert het aantal afwijzingen!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rang",
                points: "Punten",
                medianUserScore: "Gemiddelde <strong>Speler Score</strong>",
                memberCount: "Leden <strong>aantal</strong>",
            },
            barCharts: {
                clickSlice: "Klik op een segment voor details (per lid)",
                tier1: "Tier 1",
                tier2: "Tier 2",
                tier3: "Tier 3",
                drillDown: "Terug {0}"
            },
            idealCandidate: {
                heading: "Ideale Kandidaat",
                description: "Zou een score hebben van ongeveer {medianScore} en zou een of meer van de volgende bonusgoederen hebben: {boosts}",
                note: "Sommige combinaties zijn niet mogelijk. Zie {0}"
            },
            memberGoodsTable: {
                heading: "Leden Goederen Productie",
                description: `Deze tabel berekent hoeveel van elk goed jouw broederschap produceert. We maakten daarbij een inschatting wat het bonuspercentage van alle leden is, en nemen standaard aan dat elk lid 3x per dag goederen ophaalt (2x9u en 1x3u). Om de nauwkeurigheid te verbeteren kun je jouw leden vragen wat hun daadwerkelijke percentages zijn en die hier beneden invullen. Je kunt alle informatie opslaan en dat zal de volgende keer dat je deze pagina laadt getoond worden. De grafieken bovenstaande grafieken zullen automatisch updaten met alle aanpassingen die je maakt. Ga met je muis over een individuele kolomkop voor meer informatie.'
                `,
                refreshButtonText: 'Ververs ledenlijst',
                refreshButtonTip: 'Nieuwe leden toevoegen, oude leden verwijderen, gemeenschapsrollen bijwerken en huidige scores bijwerken.',
                inactiveWarningTip: 'Speler kan niet actief zijn, Score laatst aangepast op: {0}',
                collectsPerDayValidation: "Waarde moet tussen 1 en 6 zijn",
                boostPercentValidation: "Waarde moet tussen 40 - 700 zijn, zonder gebruik van Zalen o/d Berg",
                perDayShort: "/dag",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "The players score, please note this is not updated in realtime.  It's updated several times a week.",
                chapterTip: "Dit is het hoofdstuk waar de speler(s) in zitten.  Referentie: Elementals = 12, Halflings = 11, etc.",
                boostTip: "De spelers BONUS en aantal goederen geproduceerd per dag.",
                collectsPerDayTip: `***EDITABLE*** <br/>Inningen Per Dag. Dit is het aantal keren dat de speler goederen inned van zijn fabrieken. De waarde moet tussen 1 - 6 zijn.  1 = 1x24uur, 2=2x9uur, 3=2x9uur + 1x3uur, 4=1x9uur + 3x3uur, 5=4x3uur + 1x9uur, 6=5x3uur + 1x9uur<BR/>Meer info zie FAQ.`,
                relicBoostPercentTip: `***EDITABLE***<br/>The boost percent from relics, it's between 40-700.  It should not include the players Mountain Hall Percent.  That is detected automatically and added to this number`,
                mountainHallPercentTip: "Dit is het Mountain Zalen od Berg percentage dat we voor deze gebruiker hebben gedetecteerd. Het wordt gebruikt in combinatie met de boost-%'s om het totale boostpercentage te berekenen.",
                updatedTip: "This is the when the players city was last analyzed.  This process is what sets the boosts, elven architect data, calculates production from all manufactories, mountain hall %, and more. City map data is periodically fetched automatically but you can force an update below by clicking the refresh button.",

            },
            coinsAndSuppliesTable: {
                heading: "Productie van munten / voorraden",
                description: `The key column here is "Supplies Left" as it indicates whether a member will produce enough supplies to keep their
                manufactories producing 24/7.  Use the toggle switches below to take into account the players minimum culture boost (which is the boost you'd have if you had no neighborly help)
                and/or the number of times the member collects per day (as specified in Goods Table above).  Turning both off is useful if you want to see how much of the supplies are attributed
                to more manufactories or a higher culture boost. Finally, please note that having low negative (~10% of total) number of supplies left is fairly common. There are many ways players
                supplement their supplies such as by visiting neighbors, producing supplies at faster intervals (Beverages, Simple Tools, Bread...) or using Power of Provision spells.
                Think of the negative value as what you'd need to make up on a daily basis by doing one of these options.
                NOTE: at the moment troop production is not taken into account in the supplies used (Only Tier 1, Tier 2, and Tier 3 goods) so you may need more.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min Boost %",
                made: "Gemaakt",
                used: "Gebruikt",
                left: "Over",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Het percentage van de cultuurbonus.  BELANGRIJK: dit is berekend ZONDER BURENHULP op cultuurgebouwen. In realiteit zal het waarschijnlijk hoger liggen in de steden.",
                moneyComputedTip: "De hoeveelheid munten geproduceerd per dag, inclusief alle muntenproducties van Oude Wonderen",
                moneyUsedComputedTip: "De hoeveelheid munten nodig voor productie goederen.",
                moneyRemainingComputedTip: "Munten - Munten gebruikt, is het verschil wat de speler overhoud iedere dag",
                suppliesComputedTip: "Het aantal voorraden dat geproduceerd zou worden als alle werkplaatsen op 24x1 (Gereedschapskist) zouden staan + alle Oude Wonderen. (houdt geen rekening met setbonussen)",
                suppliesUsedComputedTip: "Het aantal voorraden gebruikt bij de procuctie van goederen. HOUDT GEEN REKENING met de voorraden die gebruikt worden in je kazerne! Zie uitleg hierboven.",
                suppliesRemainingComputedTip: "Voorraden - Gebruikte voorraden, het is de winst of verlies in voorraden die een speler iedere dag zal hebben",
                manaTip: "De hoeveelheid mana die iedere 24uur geproduceerd wordt (houdt geen rekening met de Drakenabdij)",
            },
            popCultureTable: {
                heading: "Bevolking/Cultuur Details",
                description: 'De tabel hieronder toone de bevolking/cultuur voor ieder lid. Beweeg je muis over de kolomtitels voor meer informatie.',

                // Icon Sub-Headings
                minBoostPercent: "Min Boost %",
                levels: "Levels",
                total: "Totaal",
                working: "Werkend",
                available: "Beschikbaar",
                required: "Benodigd",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Totaal aantal oude wonderen levels die speler heeft.",
                cultureBoostPercentTip: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                totalPopulationTip: "Totale Cultuur van je gebouwen en wonderen",
                workingPopulationTip: "Bevolking aan het werk - Aantal zoals in gebruik in bv fabrieken",
                availablePopulationTip: "Beschikbare bevolking",
                totalCultureTip: "Total Culture produced by culture buildings, culture/population hybrid buildings and ancient wonders",
                requiredCultureTip: "Cultuur benodigd voor al je gebouwen",
                availableCultureTip: "Beschikbare cultuur",
            },
            cityCoverageTable: {
                heading: "Stadsdekking",
                description: "Geeft aan hoeveel tegels in elke stad worden gebruikt voor het betreffende type gebouw. De lege tegels zijn tegels die momenteel niet worden gebruikt.",
                tiles: 'Tegels'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Wekelijks Email Overzicht",
                description: "We genereren automatisch wekelijkse rapporten die geschikt zijn om te delen met je broederschaps-leden. Een nieuw wekelijks rapport zal elke zondag beschikbaar zijn (rond ongeveer 20:00 uur UTC) voor de vorige week. Kopieer eenvoudig de onderstaande blurb en plak!",
                selectReportHint: "Selecteer overzicht voor de week eindigent op",
                reportsAreOptimizedFor: "E-mailrapporten zijn geoptimaliseerd voor weergave in het Elvenar-berichtensysteem, zodat de kolommen zo goed mogelijk worden uitgelijnd en gebruikersnamen worden afgekapt, zodat het in één bericht past.",
                accolades: "Onderscheidingen",
                tourneyChamp: " - Tournooi Kampioen (this week): {0}",
                tourneyHero: " - Tournooi Kampioen (laatste 4 weken): {0}",
                highestGrowthPlusPercentage: " - Hoogste groei (points & percentage): {0}",
                highestGrowthPoints: " - Hoogste groei(punten): {0}",
                highestGrowthPercentage: " - Hoogste groei (percentage): {0}",
                highestGrowthError: " - Hoogste groei: Kan niet bepaald worden op dit moment",
                newPersonalRecords: "Nieuw Personlijk Record",
                userSetANewPersonalRecordFor: " * {0} set a new personal record for: {1}",
                allMembersByPointGainThisWeek: "ALLE LEDEN bij punten stijging / Percentage (deze week)",
                tournamentPointsHeader: "TOURNOOI Punten (deze week / TOTAAL SINDS {0})",
                top8ByPercentage: "TOP 8 op Percentage (deze week)",
                top8ByPointsSince: "TOP 8 op Punten (Sinds {0})",
                top8ByPercentageSince: "TOP 8 op Percentage (Sinds {0})",
                reportGeneratedBy: "Report generated by elvenstats.com, for more see: ",
                mostPointsInAWeek: "Meeste punten in een week",
                highestTournamentScore: "Hoogste toernooi score",
                highestTournamentRank: "Hoogste toernooi plaats",
                insufficientHistoryForThesePlayers: "* Omitted: {0} due to insufficient history.  They will be included next week",
                insufficientHistory1Week: "* Onvoldoende geschiedenis voor dit gedeelte. Kom volgende week terug!",
                insufficientHistory4Weeks: "* Insufficient History for this section. 4 weeks of history is needed. Check back soon!",
            },
            memberHistory: {
                heading: "Geschiedenis broederschap leden",
                noChangesDetected: "Geen leden wijziging gevoonden sinds {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'U heeft niet-opgeslagen wijzigingen. Als je klaar bent met het bewerken van je broederschap, klik je op de knop Opslaan.',
                standbyImporting: 'Moment: we importeren enkele zaken die op dit moment nog ontbreken over uw broderschap genoten',
                limitedHistory: "We zijn pas recent deze {0} beginnen volgen, dus er is slechts een beperkte geschiedenis.  Iedere zondag zullen hier wekelijkse momentopnames verschijnen, dus kom snel weer kijken",
                noChangesSinceTrackingBegan: "Geen wijzigingen sinds de aanvang",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Broederschaps Geschiedenis"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Realtime updates z.",
            realTimeUpdatesNotAvailableDescription: "Dit gebeurt meestal nadat de Elvenar-spelservers opnieuw zijn opgestart om een update te implementeren of voor onderhoud. Zodra dit gebeurt, moet ElvenStats handmatig inloggen op alle gameservers voordat informatie op afroep kan worden opgehaald. Probeer uw aanvraag binnen een paar uur. In de tussentijd is de site wel volledig functioneel.",
            copyToClipboardSuccessful: "Kopiëren naar klembord geslaagd",
            copyToClipboardFailed: "Kopiëren mislukt, markeer het volledige tekstgedeelte en voer vervolgens CTRL + C uit",
            errorOccurredImporting: "Error Occurred. Importing your users.",
            errorOccurredImportingMessage: "An error occurred trying to import your users.  Please try again.  If the error, persists please contact us.",
            errorOccurredImportingWillNotBeAvailableInReports: "Users which have not been imported will not be included in the reports.",
            finishedSyncSuccessful: "Finished, Sync was successful!",
            playerIsAnonymous: "Speler heeft verzocht zijn gegevens niet te tonen in elvenstats.com",
            inactiveWarningTip: "Deze speler kans inactief zijn.  Geen score wiiziging sinds: {0}",
            isFriendTip: "Dit is vriend van ElvenStats.  Zij hebben bijgedragen in op enige wijze bij deze site!",
        }
    }

}


// WEBPACK FOOTER //
// ./src/lang/nl.js